
import { useUsers } from '../context/users-context';
import { UsersActionDialog } from './users-action-dialog';
import type { UserProfile } from '@/lib/types/core';

interface UsersDialogsProps {
  onUserMutated?: (_user: UserProfile) => void;
}

export function UsersDialogs({ onUserMutated }: UsersDialogsProps) {
  const { dialogOpen, setDialogOpen, currentUser, userToMutate: _userToMutate } = useUsers();
  // console.warn('[UsersDialogs rendering] dialogOpen:', dialogOpen, 'currentUser:', currentUser);

  const handleCloseDialog = () => {
    if (document.activeElement && typeof (document.activeElement as HTMLElement).blur === 'function') {
      (document.activeElement as HTMLElement).blur();
    }
    setDialogOpen(null);
  };

  return (
    <>
      <UsersActionDialog
        key='user-invite-dialog'
        open={dialogOpen === 'add'}
        onOpenChange={(isOpen) => {
          if (!isOpen) handleCloseDialog();
        }}
        mode='create'
        {...(onUserMutated && { onUserMutated })}
      />

      <UsersActionDialog
        key={currentUser ? `user-edit-${currentUser.id}` : 'user-edit-placeholder'}
        open={dialogOpen === 'edit' && !!currentUser}
        onOpenChange={(isOpen) => {
          if (!isOpen) handleCloseDialog();
        }}
        mode='edit'
        userToEdit={currentUser}
        {...(onUserMutated && { onUserMutated })}
      />
    </>
  );
}
